var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"header",attrs:{"to":{name: 'Login'}}},[_c('inline-svg',{attrs:{"src":require('@/assets/svg/logo-inline.svg')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }